const showStickyAtc = (): void => {
  const toggleElement: HTMLElement | null = document.querySelector('.product-sticky-atc')
  if (!toggleElement) {
    return;
  }

  const toggleTrigger: HTMLDivElement | null = document.querySelector('[data-product-form] [data-product-form-submit]')

  if (!toggleTrigger) {
    return;
  }

  let togglePosition = toggleTrigger.offsetTop

  window.addEventListener('resize', () => {
    togglePosition = toggleTrigger.offsetTop
  });

  window.addEventListener('load', () => {
    if (window.innerHeight < togglePosition) {
      toggleElement.classList.add('product-sticky-atc--show')
    }
  });

  document.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY
    // If we've not scrolled to the button yet (and it's not visible)
    // or we've scrolled past the button (and it's off the screen)
    if (scrollPosition < (togglePosition - window.innerHeight) + toggleTrigger.getBoundingClientRect().height || scrollPosition > togglePosition) {
      toggleElement.classList.add('product-sticky-atc--show')
    } else {
      toggleElement.classList.remove('product-sticky-atc--show')
    }
  });
}

export default showStickyAtc